<template>
    <wrapper-edit class="paas-select-wrap"
                  :wrapper-width="wrapperWidth"
                  :content-padding = "contentPadding"
                  offsetHeight="300"
                  @back="paasPageBack">
        <div slot="head">
            <h6>图片空间</h6>
        </div>
        <div class="paas-split" slot="form">
            <Split v-model="split" :min="siderWidth" v-height="{offsetHeight:380}">
                <div slot="left" class="paas-split-pane" ref="treeWrap" >
                    <wrapper-tree
                            title="图片分类"
                            ref="wrapperTree"
                            icon = "iconfont iconnavicon-lcpz"
                            :offsetHeight = "370"
                            :serviceUrl="serviceUrl"
                            :currentIdFiledName="categoryFiledName"
                            :start-tree-node="startTreeCode"
                            tree-node-icon="iconfont iconpaixing"
                            treeType="query"
                            @on-node-click="paasNodeClick">
                    </wrapper-tree>
                </div>
                <Widget
                        title="图片"
                        icon="iconfont iconxitongguanli-jianchayiju"
                        class="paas-split-pane"
                        slot="right" >
                    <div slot="toolbar" class="toolbar-wrap" >
                        <BtnUploader :fileList.sync="fileList"
                                     :businessId="uploadParams.fileBusinessId"
                                     :tempId="uploadParams.tempId"
                                     uploadTitle="上传图片"
                                     :businessType="uploadParams.fileBusinessType"
                                     :single="false"
                                     :businessProperty="uploadParams.fileBusinessProp"
                                     ref="btnUploader"
                                     basedictStorage="ossServer"
                                     :parentNodeId="parentNodeId"
                                     :childCategory="productNo"
                                     @save-check="saveCheckedFile"
                                     :thumbWidth="queryByCategoryParam.thumbWidth"
                        ></BtnUploader>
                    </div>
                    <div slot="content"  class="paas-select-right-image" v-height="{offsetHeight:380}">
                        <div class="image-wrap">
                            <Card
                                    v-for="(item,index) in fileList"
                                    :key="index" bordered
                                    @click.native ="selectCard(item)"
                                    :class="[item.check?'active-card':'','img-card']">
                                <div style="text-align:center">
                                    <img :src="item.thumbnailUrl?item.thumbnailUrl:item.originalUrl" width="100" height="100">
                                    <p :title="item.filename" class="file-name">{{item.filename}}</p>
                                </div>
                            </Card>
                        </div>
                    </div>
                </Widget>
            </Split>
            <Modal
                    v-model="categoryModal"
                    class="category_modal"
                    title="添加分类"
                    @on-ok="addCategory"
                    @on-cancel="cancel">
                <Form :model="categoryData" :label-width="80">
                    <FormItem label="上级分类:" >
                        <Input v-model="categoryData.parentName"
                               @on-focus="showFlag=true"></Input>
                        <select-tree ref="categoryTree"
                                     @selected-tree-value="updateTreeParentNode"
                                     serviceUrl='/sys/image/category'
                                     v-show="showFlag"/>
                    </FormItem>
                    <FormItem label="分类名称:">
                        <Input v-model="categoryData.parentName" placeholder="请输入分类名称"></Input>
                    </FormItem>
                </Form>
            </Modal>
        </div>
    </wrapper-edit>
</template>

<script>
    import Widget from "@/components/paas/widget";
    import wrapperTree from '@/components/paas/wrapper-tree'
    import metaFile from "@/assets/js/file/meta-file.js";
    import wrapperEdit from "@/components/paas/wrapper-edit";
    import SelectTree from '@/components/paas/selectTree';
    import { getImagesByCategoryId } from "@api/upload.js";
    import BtnUploader from "@components/paas/file/btn-uploader.vue";
    export default {
        name: "imageSelect",
        mixins:[metaFile],
        components:{Widget,wrapperTree,wrapperEdit,SelectTree,BtnUploader},
        props:{
            multiple: {
                type: Boolean,
                default: false
            },
            //缩略图
            thumbnailWidth:{
                type:[Number,String],
                default: function () {
                    return 0 ||'0px'
                }
            },
            thumbnailHeight:{
                type:[Number,String],
                default: function () {
                    return 0 ||'0px'
                }
            },
            uploadParams:{
                type:Object,
                default:function(){
                    return {};
                },
            },
            uploadAction:{
                type:String,
                default:'',
            },
            checkedFile:{
                type:Array,
                default:[],
            },
            parentNodeId:{
                type:String,
                default:""
            },
            productNo:{
                type:String,
                default:""
            }
        },
        data() {
            return {
                serviceUrl:'/sys/image/category',
                wrapperWidth:'100%',
                contentPadding:'0px',
                split:0.3,  //面板位置，可以是 0~1 代表百分比，或具体数值的像素，可用 v-model 双向绑定
                siderWidth:"250px",  //sider的宽度，必须是String类型的
                categoryFiledName:'id',
                startTreeCode:'',  //起始树节点,只传paasLikeTreeCode的值 '100'、'101'等等
                selectCategoryId:'', //选中分类id
                queryByCategoryParam:{
                    query_EQ_businessId:"",
                    thumbWidth:180
                },
                categoryModal:false,
                categoryData:{
                    parentId:'',
                    parentName:'',
                    sysImageCategoryName:'',
                },
                showFlag:false,
                fileList:[],
                selectImgs:[],
            }
        },
        watch:{
            uploadParams:{
                handler(newName) {
                    this.uploadParams = newName;
                },
                // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
                immediate: true
            },
            uploadAction(newVal){
                this.action = newVal;
            },
        },
        methods: {
            saveCheckedFile(file){
                if(this.multiple){
                    file.check = true;
                    this.selectImgs.push(file);
                    //this.fileList.push(file);
                    this.$emit('save-file',this.selectImgs);
                }
               else{
                    file.check = true;
                    this.selectImgs = [];
                    this.selectImgs.push(file);
                    //this.fileList.push(file);
                    this.$emit('save-file',this.selectImgs);
                }

            },
            paasPageBack(){
                this.$emit("on-close");
            },
            /**
             * 监测到点击左侧树表
             * @param node
             */
            paasNodeClick(node) {
                this.selectCategoryId = node.id;
                this.uploadParams.sysImageCategoryId = node.id;
                this.uploadParams.sysImageCategoryName = node.title;
                this.getImagesByCategoryId(node.id);
            },
            /**
             * 查询分类图片
             * @param id
             */
            getImagesByCategoryId(id) {
                if(id){
                    this.queryByCategoryParam.query_EQ_businessId = id;
                    getImagesByCategoryId(this.queryByCategoryParam).then(res =>{
                        if (res.code === 200) {
                            this.fileList = res.data;
                        }
                    });
                }
            },

            /**
             * 点击添加分类：显示模态框、更新模态框的树表
             * */
            showOrUpdateModal(){
                this.clearAddCategoryModalData();
                this.categoryModal = true;
                this.$refs.categoryTree.queryTreeDatas();
            },
            /**
             * 清空添加分类的form的数据
             * */
            clearAddCategoryModalData(){
                for(let key in this.imageData){
                    this.imageData[key] = "";
                }
            },
            addCategory(){

            },
            /**
             * 添加分类时弹出modal显示的选中父节点
             * @param node
             */
            updateTreeParentNode(node) {
                this.categoryData.parentId = node.id;
                this.categoryData.parentName = node.title;
                this.showFlag = false;
            },
            /**
             * 选中卡片
             * @param item
             */
            selectCard(item){
                if(this.multiple){
                    if(this.fileList != null && this.fileList.length > 0){
                        for(let i = 0; i < this.fileList.length;i++){
                            if(this.fileList[i].id === item.id){
                                if(!this.fileList[i].check){
                                    this.fileList[i].check = true;
                                    this.selectImgs.push(this.fileList[i]);
                                    this.$emit('save-file',this.selectImgs);
                                }
                            }
                        }
                    }
                }else{
                    if(this.fileList != null && this.fileList.length > 0){
                        for(let i = 0; i < this.fileList.length;i++){
                            if(this.fileList[i].id === item.id){
                                this.fileList[i].check = true;
                                this.selectImgs = [];
                                this.selectImgs.push(this.fileList[i]);
                                this.$emit('save-file',this.selectImgs);
                            }else{
                                this.fileList[i].check = false;
                            }
                        }
                    }
                }
            },

        }
    }
</script>

<style scoped>
    .paas-split{
        padding:10px;
    }
    .paas-split >>> .wrapper{
        padding:0px;
    }
    .paas-split-pane,.paas-split >>> .paas-split-pane{
        padding-left:5px;
    }
    .toolbar-wrap{
        display: flex;
        align-items: flex-start;
        margin-top: -5px;
    }
    .toolbar-wrap > button{
        margin:0px 3px;
    }
    .page-footer{
        display:flex;
        justify-content:space-between;
        margin-top:10px;
    }
    .paas-upload-input {
        display: none;
    }
    .image-wrap{
        display:flex;
        flex-wrap: wrap;
        justify-content: flex-start
    }
    .file-name{
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .img-card{
        margin:5px;
    }
    .image-wrap > .active-card{
        border:1px solid red;
        background: #ffffff;
        opacity:0.6;
        filter: alpha(opacity=60);
    }
    .paas-select-right-image,.paas-split-pane >>> .content{
        overflow: auto;
    }
    .category_modal{
        z-index:99999;
    }
</style>
